import i18n from '../i18n.js';

export const formatDate = (dateInput, options = {}) => {
  if (!dateInput) return '';
  let date;
  if (dateInput instanceof Date) {
    date = dateInput;
  } else {
    // Treat YYYY-MM-DD as local noon to avoid timezone rollback
    const isoOnly = /^\d{4}-\d{2}-\d{2}$/.test(dateInput);
    date = new Date(isoOnly ? dateInput + 'T12:00:00' : dateInput);
  }
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString(i18n.language || 'en-US', options);
};

export const formatDateTime = (dateInput, options = {}) => {
  if (!dateInput) return '';
  let date;
  if (dateInput instanceof Date) {
    date = dateInput;
  } else {
    const isoOnly = /^\d{4}-\d{2}-\d{2}$/.test(dateInput);
    date = new Date(isoOnly ? dateInput + 'T12:00:00' : dateInput);
  }
  if (isNaN(date.getTime())) return '';
  return date.toLocaleString(i18n.language || 'en-US', options);
};

export default formatDate;
